import * as React from 'react';
import { puser } from '@/proto/proto';
import Header from '@/components/organisms/common/Header';
import { Layout, LayoutContent } from '@/components/atoms';
import SideNavigator from '@/components/organisms/common/SideNavigator';
import Footer from '@/components/organisms/common/Footer';

export type SiderTemplatePropType = {
  children?: React.ReactNode;
  user: puser.IPbUser;
  logout: () => void;
};

const SiderTemplate = ({ children, user, logout }: SiderTemplatePropType) => {
  return (
    <Layout className="template-sider">
      <Header user={user} count={0} logout={logout} />
      <Layout>
        <SideNavigator />
        <LayoutContent>{children}</LayoutContent>
      </Layout>
      <Footer />
    </Layout>
  );
};

export default SiderTemplate;
